import { expectfulUrl, healthPath } from 'lib/urls'
import { HealthNavItem } from './types'

export const DEFAULT_BL_HEALTH_NAV_ITEMS: Array<HealthNavItem> = [
  {
    buttonText: 'Check Eligibility',
    image:
      '//images.babylist.com/image/upload/f_auto,q_auto/v1691429866/Health_BLHealth_3_km6bay.png',
    link: healthPath,
    newWindow: true,
    subtext:
      "We'll take care of contacting your provider and billing your insurance.",
    title: 'Order your free breast pump through insurance',
  },
  {
    buttonText: 'Meet Expectful',
    image:
      '//images.babylist.com/image/upload/f_auto,q_auto/v1691189394/Health_Expectful_2_ez2lho.png',
    link: expectfulUrl,
    newWindow: true,
    subtext:
      'Expectful is a haven of holistic care for fertility, pregnancy and motherhood.',
    title: 'Care for moms from fertility to baby',
  },
]
